module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"ru":{"shareable":"Поделиться ссылкой","personal":"Персональное приглашение","excel":"Импорт из Excel"}}')
  delete Component.options._Ctor
}
